// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RateHouseholdChatMessageMutationVariables = Types.Exact<{
  messageID: Types.Scalars['ID']['input'];
  rating: Types.HouseholdChatFeedbackRating;
}>;


export type RateHouseholdChatMessageMutation = { __typename?: 'Mutation', rateHouseholdChatMessage: string };

export type SubmitHouseholdChatFeedbackMutationVariables = Types.Exact<{
  messageID: Types.Scalars['ID']['input'];
  feedback: Types.Scalars['String']['input'];
}>;


export type SubmitHouseholdChatFeedbackMutation = { __typename?: 'Mutation', submitHouseholdChatFeedback: string };

export const Operations = {
  Mutation: {
    RateHouseholdChatMessage: 'RateHouseholdChatMessage' as const,
    SubmitHouseholdChatFeedback: 'SubmitHouseholdChatFeedback' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const RateHouseholdChatMessageDocument = gql`
    mutation RateHouseholdChatMessage($messageID: ID!, $rating: HouseholdChatFeedbackRating!) {
  rateHouseholdChatMessage(messageID: $messageID, rating: $rating)
}
    `;
export type RateHouseholdChatMessageMutationFn = Apollo.MutationFunction<RateHouseholdChatMessageMutation, RateHouseholdChatMessageMutationVariables>;

/**
 * __useRateHouseholdChatMessageMutation__
 *
 * To run a mutation, you first call `useRateHouseholdChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateHouseholdChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateHouseholdChatMessageMutation, { data, loading, error }] = useRateHouseholdChatMessageMutation({
 *   variables: {
 *      messageID: // value for 'messageID'
 *      rating: // value for 'rating'
 *   },
 * });
 */
export function useRateHouseholdChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<RateHouseholdChatMessageMutation, RateHouseholdChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RateHouseholdChatMessageMutation, RateHouseholdChatMessageMutationVariables>(RateHouseholdChatMessageDocument, options);
      }
export type RateHouseholdChatMessageMutationHookResult = ReturnType<typeof useRateHouseholdChatMessageMutation>;
export type RateHouseholdChatMessageMutationResult = Apollo.MutationResult<RateHouseholdChatMessageMutation>;
export type RateHouseholdChatMessageMutationOptions = Apollo.BaseMutationOptions<RateHouseholdChatMessageMutation, RateHouseholdChatMessageMutationVariables>;
export const SubmitHouseholdChatFeedbackDocument = gql`
    mutation SubmitHouseholdChatFeedback($messageID: ID!, $feedback: String!) {
  submitHouseholdChatFeedback(messageID: $messageID, feedback: $feedback)
}
    `;
export type SubmitHouseholdChatFeedbackMutationFn = Apollo.MutationFunction<SubmitHouseholdChatFeedbackMutation, SubmitHouseholdChatFeedbackMutationVariables>;

/**
 * __useSubmitHouseholdChatFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitHouseholdChatFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitHouseholdChatFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitHouseholdChatFeedbackMutation, { data, loading, error }] = useSubmitHouseholdChatFeedbackMutation({
 *   variables: {
 *      messageID: // value for 'messageID'
 *      feedback: // value for 'feedback'
 *   },
 * });
 */
export function useSubmitHouseholdChatFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SubmitHouseholdChatFeedbackMutation, SubmitHouseholdChatFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitHouseholdChatFeedbackMutation, SubmitHouseholdChatFeedbackMutationVariables>(SubmitHouseholdChatFeedbackDocument, options);
      }
export type SubmitHouseholdChatFeedbackMutationHookResult = ReturnType<typeof useSubmitHouseholdChatFeedbackMutation>;
export type SubmitHouseholdChatFeedbackMutationResult = Apollo.MutationResult<SubmitHouseholdChatFeedbackMutation>;
export type SubmitHouseholdChatFeedbackMutationOptions = Apollo.BaseMutationOptions<SubmitHouseholdChatFeedbackMutation, SubmitHouseholdChatFeedbackMutationVariables>;